import { render, staticRenderFns } from "./Auto.vue?vue&type=template&id=5b5735b1"
import script from "./Auto.vue?vue&type=script&lang=ts"
export * from "./Auto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports